import React, { useState, useEffect } from "react";

import { api } from "@/APIRequests";
import { Button2 } from "@/components/UI2/atoms/Button";
import { Dropdown, FormField } from "@/component-library";
import { ModalControlled2 } from "@/components/UI2/molecules/Modal";

export const PatientStatusChangeModal = ({
  cancelHandler,
  confirmHandler,
  newPatientStatus,
  oldPatientStatus,
  patientName,
}) => {
  const [reasonSelected, setReasonSelected] = useState("");
  const [reasonDropdownValue, setReasonDropdownValue] = useState(null);
  const [reasonOptions, setReasonOptions] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await api.public.get_patient_inactivation_reasons({
        params: { showLoader: true },
      });
      const sortedOptions = response.sort((optionA, optionB) =>
        optionA.label.localeCompare(optionB.label),
      );

      setReasonOptions(sortedOptions);
    })();
  }, []);

  const title =
    newPatientStatus === "INACTIVE" ? `You are inactivating ${patientName}` : "Activate Member";

  return (
    <ModalControlled2
      className="tw:w-full tw:max-w-xl"
      isOpen={true}
      onOpenChange={(open) => !open && cancelHandler()}
      title={title}
    >
      {newPatientStatus === "INACTIVE" ? (
        <>
          <FormField label="Reason for Inactivation">
            {/* TODO: Use modern dropdown*/}
            <Dropdown
              onChange={(e) => {
                setReasonDropdownValue({
                  label: e.target.value,
                  value: e.target.value,
                });
                setReasonSelected(e.target.value);
              }}
              options={reasonOptions}
              placeholder="Select Reason for Inactivation"
              value={reasonDropdownValue}
            />
          </FormField>

          <p className="body-sm">
            The patient will be notified by email, unless &ldquo;Deceased&rdquo; is selected.
          </p>

          <div className="tw:flex tw:gap-2 tw:self-end">
            <Button2 onPress={cancelHandler} variant="secondary">
              Cancel
            </Button2>

            <Button2
              isDisabled={!reasonSelected}
              onPress={() => confirmHandler(reasonSelected)}
              variant="primary"
            >
              Inactivate Member
            </Button2>
          </div>
        </>
      ) : (
        <>
          <div className="tw:flex tw:flex-col tw:gap-2">
            <p className="">
              Are you sure you want to activate <span data-private>{patientName}</span>?
            </p>

            <p>
              Their status will be changed to their previous active status:{" "}
              <b>{oldPatientStatus}</b>
            </p>
          </div>

          <div className="tw:flex tw:gap-2 tw:self-end">
            <Button2 onPress={cancelHandler} variant="secondary">
              No, Cancel
            </Button2>

            <Button2 onPress={() => confirmHandler()} variant="primary">
              Yes, Activate Member
            </Button2>
          </div>
        </>
      )}
    </ModalControlled2>
  );
};
